import script from "./Activity_Goodkidtest_20260508.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_Goodkidtest_20260508.vue?vue&type=script&setup=true&lang=js"

import "./Activity_Goodkidtest_20260508.vue?vue&type=style&index=0&id=9a4d86b0&lang=less&scoped=true"
import "./Activity_Goodkidtest_20260508.vue?vue&type=style&index=1&id=9a4d86b0&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a4d86b0"]])

export default __exports__